import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const userServices = {
  switchLoginAccount,

  getMembers,
  getSingleMember,
  statusUpdateMember,

  changePassword,
  getCurrectLoginUser,

  updateProfile,
  sendEmailOTP,
  updateNewEmail,

  checkRegistredUser,
  sendNotificationForRegistration,

  getCountries
};

// Get Current User Detail
async function getCurrectLoginUser() {
  try {
    const signal = cancelPreviousRequest("getCurrectLoginUser");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getCurrectLoginUser`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get All Member
async function getMembers(status, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest(`getMembers/${status}`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getMembers/${status}?search=${searchData || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getMembers/${status}?search=${searchData || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Member
async function getSingleMember(userId) {
  try {
    const signal = cancelPreviousRequest("getSingleMember");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleMember/${userId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Status Update Member
async function statusUpdateMember(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}statusUpdateMember`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Change Password
async function changePassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}changePassword`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Update Profile
async function updateProfile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProfile`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Switch Login Account
async function switchLoginAccount(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}switchLoginAccount`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  if(!userData?.loginPropertyId){
    handleResponse(data);
  }
  return data;
}

// Send Email OTP
async function sendEmailOTP(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendEmailOTP`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Update New Email
async function updateNewEmail(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateNewEmail`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

async function checkRegistredUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkRegistredUser`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Send Notification for Registration
async function sendNotificationForRegistration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendNotificationForRegistration`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Get Country
async function getCountries() {
  try {
    const signal = cancelPreviousRequest(`getCountries`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getCountries`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}